import { classed } from "@/components/classed.config";

export const Heading = classed.h1(
  "text-center text-xl font-medium leading-snug md:text-3xl",
);
export const Description = classed.p(
  "leading-loose text-xs md:text-sm text-muted-foreground",
);
